import { SmoothScroll } from "../components/site/SmoothScroll";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { Calculator } from "../components/site/Calculator";
import { Solutions } from "../components/site/Solutions";
import { Impact } from "../components/site/Impact";
import { CoverageMap } from "../components/site/CoverageMap";
import { FindShop } from "../components/site/FindShop";
import { Advantage } from "../components/site/Advantage";
import { Leadership } from "../components/site/Leadership";
import { Testimonials } from "../components/site/Testimonials";
import { Gallery } from "../components/site/Gallery";
import { JoinForm } from "../components/site/JoinForm";
import { StatusCheck } from "../components/site/StatusCheck";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <div className="site grain min-h-screen bg-ink text-white" data-testid="landing-page">
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Calculator />
        <Solutions />
        <Impact />
        <CoverageMap />
        <FindShop />
        <Advantage />
        <Leadership />
        <Testimonials />
        <Gallery />
        <JoinForm />
        <StatusCheck />
      </main>
      <Footer />
    </div>
  );
}
